import { CategoryRepository } from "../../../../data/repository/category/CategoryRepository";
import { QuestionRepository } from "../../../../data/repository/question/QuestionRepository";
import { Category } from "../../../model/Category";
import { Question } from "../../../model/Question";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetQuestionUseCase {
  invoke: (id: string) => Promise<ResponseState<Question>>;
}

export class GetQuestionUseCaseImpl implements GetQuestionUseCase {
  private questionRepository: QuestionRepository;

  constructor(questionRepository: QuestionRepository) {
    this.questionRepository = questionRepository;
  }

  async invoke(id: string): Promise<ResponseState<Question>> {
    try {
      let response = await this.questionRepository.getQuestion(id);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
